// extracted by mini-css-extract-plugin
module.exports = {"lottie":"styles_lottie__pepqX","icon":"styles_icon__Zygph","skeleton-animation":"styles_skeleton-animation__BQ4Uh"};